import React from 'react'
function MeetTitle({ meet, plan, isOwner }) {
  return <h1 className="title">
    {meet.name}
    { isOwner && plan && ["trial", "small", "medium", "large"].indexOf(plan.name) !== -1 ?
      <div><small>Up to {plan.maxSize} players</small></div>
    : null }
    <style jsx>{`
       .title small {
         color: #808080;
         font-weight: normal;
         font-size: 0.5em;
       }
    `}</style>
  </h1>
}
export default MeetTitle
